import amansingh from "../assets/amansingh.jpg";
import TypeWriters from "../Components/TypeWriter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Exp from "../Components/Exp";
import Skills from "../Components/Skills";
import Portfolio from "../Components/Portfolio";
import ContactUs from "../Components/ContactUs";

const Home = () => {
  const amansinghportfolio = {
    backgroundImage: `url(${amansingh})`,
  };
  return (
    <>
      <div className="wrapper ">
        <div class="background-bg ">
          <div class=" background-filter">
            <div class="background-img" style={amansinghportfolio}></div>
          </div>
        </div>

        {/* ?Section Start  */}
        <div class="section started" id="section-started">
          <div class="centrize full-width">
            <div class="vertical-center">
              {/* <!-- title --> */}
              <h1 class="h-title">
                Aman <br />
                Singh
              </h1>

              {/* <!-- content started --> */}
              <div class="started-content">
                {/* <!-- subtitle --> */}
                <TypeWriters />

                {/* <!-- text --> */}
                <div class="h-text">
                  Hello! I am Web Developer from India, Pune. I have rich
                  experience in website design and building, also I am good at
                  wordpress. I love to talk with you about our unique Concept.
                </div>

                {/* <!-- button --> */}
                <a href="tel:+917903431801" class="btn">
                  <span class="animated-button">
                    <span>Contact Me</span>
                  </span>
                  <i class="icon fas fa-chevron-right"></i>
                </a>

                {/* <!-- mosue button --> */}
                <a
                  href="#section-contact"
                  className="btn mouse-btn"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default anchor behavior
                    const section = document.getElementById("section-contact");
                    if (section) {
                      window.scrollTo({
                        top: section.offsetTop - 50, // Adjust for fixed navbar
                        behavior: "smooth",
                      });
                    }
                  }}
                >
                  <i className="icon fas fa-chevron-down"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ?Section About   */}
        <div class="section about" id="section-about">
          <div class="content">
            {/* <!-- title --> */}
            <div class="titles">
              <div class="title">About Me</div>
              {/* <div class="subtitle">My story</div> */}
            </div>

            {/* <!-- text --> */}
            <div class="cols">
              <div class="col col-full">
                <div class="single-post-text">
                  <p>
                    With 4 years of experience in web development, I’ve worked
                    with WordPress and managed servers at both Hemocean and A2
                    Digitech Pvt Ltd. Recently, at A2 Digitech, which has become
                    a private limited company, I’ve gained experience in React,
                    handling API integration for data fetching and posting.
                  </p>
                  <p>
                    These roles have allowed me to enhance my technical skills
                    across both frontend development and server management. The
                    diverse challenges have provided valuable learning
                    opportunities, contributing to my growth as a problem
                    solver.
                  </p>
                </div>
              </div>
            </div>

            {/* <!-- info list --> */}
            <div class="info-list">
              <ul>
                <li>
                  <strong>Age:</strong> 27
                </li>

                <li>
                  <strong>Residence:</strong> India
                </li>

                {/* <li>
                  <strong>Freelance:</strong> Available
                </li> */}

                <li>
                  <strong>Address:</strong> Pune, Maharastra
                </li>

                <li>
                  <strong>Phone:</strong> +91-7903431801
                </li>

                <li>
                  <strong>E-mail:</strong> aman44722@gmail.com
                </li>
              </ul>
            </div>

            <div class="clear"></div>
          </div>
        </div>

        {/* ?Section Exprence */}
        <Exp />

        {/* ?Section skills */}
        <Skills />

        {/* ?Section Portfolio */}
        <Portfolio />

        {/* ?Section ContactUs */}
        <ContactUs />
      </div>
    </>
  );
};

export default Home;
